<template>
    <v-app id="inspire">
        <v-content>
            <v-container
                fluid
                fill-height
            >
                <v-layout justify-center>
                    <v-flex>
                        <UploadList
                            v-if="uploadList"
                            @uploadString="uploadFile($event)"
                        />
                        <deleteLocalStorage
                            v-if="checkedCertificatesTabl"
                            @clearLocalStorage="clearLocalStorage()"
                        />
                        <checkedCertificatesTable
                            v-if="checkedCertificatesTabl"
                            :checked-certificates="checkedCertificates"
                        />
                        <loadingScreen
                            v-if="loadingScreen"
                        />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import UploadList from './components/uploadList.vue'
import checkedCertificatesTable from './components/checkedCertificatesTable.vue'
import axios from 'axios'
import loadingScreen from './components/loadscreen.vue'
import deleteLocalStorage from './components/deleteLocalStorage.vue'

export default {
    components: {
        UploadList,
        checkedCertificatesTable,
        loadingScreen,
        deleteLocalStorage
    },
    data () {
        return {
            checkedCertificates: [],
            loadingScreen: false,
            uploadList: false,
            checkedCertificatesTabl: false
        }
    },
    mounted () {
        if (localStorage.getItem('data')) {
            this.uploadFile(localStorage.getItem('data'))
        } else {
            this.showUploadList()
        }
    },
    methods: {
        clearLocalStorage () {
            localStorage.removeItem('data')
            this.checkedCertificates = []
            this.showUploadList()
        },

        showUploadList () {
            this.loadingScreen = false
            this.uploadList = true
            this.checkedCertificatesTabl = false
        },

        showCerticateTable () {
            this.loadingScreen = false
            this.uploadList = false
            this.checkedCertificatesTabl = true
        },

        showLoadScreen () {
            this.loadingScreen = true
            this.uploadList = false
            this.checkedCertificatesTabl = false
        },

        uploadFile (file) {
            let formData = file
            this.showLoadScreen()
            axios.post('/checkcertificates.php',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    auth: {
                        username: 'root',
                        password: 'root'
                    }
                }).then((data) => {
                this.checkedCertificates = data.data
                this.showCerticateTable()
            })
        }
    }
}
</script>
<style>
</style>
